import { FunctionComponent } from 'react'
import {
  Autocomplete,
  CurrencyInput,
  Modal,
  Text,
} from '@conexasaude/conexa-hero'
import useChargesAndOutcomesModal from './ChargesAndOutcomesModal.hook'
import useStyles from './ChargesAndOutcomesModal.styles'
import RenderIf from '@/components/RenderIf'

const ChargesAndOutcomesModal: FunctionComponent = () => {
  const styles = useStyles()
  const {
    closeModal,
    modalOpen,
    handleBillingAndOutcome,
    allOutcomeList,
    outcomeData,
    creditCardList,
    setvalue,
    chargeAndOutcome,
    setChargeAndOutcome,
    handleOutcome,
    manualBillingWithOutcomeIsLoading,
    manualBillingBillOrReserveIsLoading,
    handleCreditCard,
  } = useChargesAndOutcomesModal()

  return (
    <Modal
      title="Cobranças e desfechos manuais"
      opened={Boolean(modalOpen)}
      primaryActionLabel="Confirmar"
      primaryAction={handleBillingAndOutcome}
      busyPrimaryAction={
        manualBillingWithOutcomeIsLoading || manualBillingBillOrReserveIsLoading
      }
      negativeActionLabel="Voltar"
      negativeAction={closeModal}
      onClose={closeModal}
      size={500}
    >
      <div css={styles.container}>
        <Text renderAs="span">Selecione uma opção: </Text>
      </div>
      <div css={styles.inputWrapper}>
        <Autocomplete
          label="Cobranças e desfecho manuais"
          placeholder="Selecione a ação"
          optionLabel="value"
          options={outcomeData || []}
          onInputChange={(_, newValue) => {
            setChargeAndOutcome(newValue)
          }}
        />
      </div>
      <div css={styles.inputWrapper}>
        <RenderIf
          condition={
            chargeAndOutcome === 'Desfecho pendente com pagamento' ||
            chargeAndOutcome === 'Desfecho pendente sem pagamento'
          }
        >
          <Autocomplete
            label="Desfecho*"
            placeholder="Selecione o desfecho"
            optionLabel="value"
            options={allOutcomeList || []}
            onInputChange={(_, newValue) => {
              handleOutcome(newValue)
            }}
          />
        </RenderIf>
      </div>
      <div css={styles.inputWrapper}>
        <RenderIf
          condition={
            chargeAndOutcome === 'Desfecho pendente sem pagamento' ||
            chargeAndOutcome === 'Cobrança manual' ||
            chargeAndOutcome === 'Reservar valor'
          }
        >
          <div css={styles.payment}>
            <Autocomplete
              label="Cartão*"
              optionLabel="endAndFlagCard"
              placeholder="Selecione o cartão"
              options={creditCardList || []}
              onInputChange={(_, newValue) => {
                handleCreditCard(newValue)
              }}
            />
            <CurrencyInput
              label="Valor*"
              onChange={event => setvalue(event.target.value)}
              placeholder="Insira o valor"
              fullWidth
            />
          </div>
        </RenderIf>
      </div>
    </Modal>
  )
}

export default ChargesAndOutcomesModal
